import React from 'react';

const location = () => {
  if(typeof document !== 'undefined') {
    return document.location;
  } else {
    return 'https://urbanize.at';
  }
};

export default () =>
  <div className="add-this">
    <a onClick={() => {
         window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(location())}`,
         'facebook-share-dialog',
         'width=626,height=436');
       }}
       title="Auf Facebook teilen">
      <span className="icon-facebook"></span>
    </a>

    <a onClick={() => {
         window.open(`https://twitter.com/share?url=${location()}`,
                     'twitter-share-dialog',
                     'width=626,height=436');
       }}
       title="Auf Twitter teilen">
      <span className="icon-twitter"></span>
    </a>

    <a onClick={() => window.print()}
       title="Seite drucken">
      <span className="icon-print"></span>
    </a>

    <a href={`mailto:?subject=Urbanize Festival&body=${location()}`}
       title="Per Email versenden">
       <span className="icon-mail"></span>
    </a>
  </div>
;



// WEBPACK FOOTER //
// ./src/components/add-this.js